import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../../_components/common/Navbar';
import SideNavBar from '../../../../_components/common/SideNavBar'
import { superAdminAreaData } from '../../OrgAdminArea/SidebarData'
import UtilityNav from '../../../../_components/common/UtilityNav'
import ModalComponent from '../../../../_components/common/Modal';
import { Table } from 'reactstrap';
import TableNew from '../../../../_components/common/Table';
import { AddMetric } from './formData';
import { SuperAdminConstants } from '../../../../_constants';
import { superAdminAction } from '../../../../_actions';

import AccessData from '../../../../_components/common/AccessData';

import tableSort from '../../../../_components/common/Sort';


class DefineMetrics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            addCompetency: false,
            deleteCompetency: false,
            editCompetency: false,
            competencyDetailsModal: false,
            competencyDetails: null,
            navData: [],


            buttonData: [],
            buttonData2: [],

            tableData: {
                default_compitency_metric_list: [],
                organisation_metric_list: [],
                combined_list: []
            },

            uneditable_combined_list: [],

            checkBoxData2: [],

            denyCompetency: false,
            addCompetency2: false,
            denyCompetency2: false,


            updateModalState: false,
            updateMessage: null,

            sortType: false,
        }
    }

    componentDidMount() {
        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }

        

        this.props.dispatch(superAdminAction.defaultDefineMetricList({analytics_organisation: +this.props.match.params.id},(response_default) => {
            this.setState({
                tableData: {
                    default_compitency_metric_list: response_default.data.default_compitency_metric_list.map(val => ({...val, 'rowCheck': true})),
                    organisation_metric_list: response_default.data.organisation_metric_list.map(val => ({...val, 'rowCheck': true, })),
                    combined_list: response_default.data.default_compitency_metric_list.map(val => ({...val, 'rowCheck': true, default: 'Default'})).concat(response_default.data.organisation_metric_list.map(val => ({...val, 'rowCheck': true, default: 'Organisation'})))
                }
            }, () => {
                this.props.dispatch(superAdminAction.combinedMetricListApi({analytics_organisation: +this.props.match.params.id}, (callbackData) => {
                    let formatedData = []
                            
                    this.state.tableData.default_compitency_metric_list.map(function(obj) { 
                        let count = 0;
                        let some_id = 0;
                        for (let i = 0; i < callbackData.data.default_competency_metrics.length; i++) {
                            if (callbackData.data.default_competency_metrics[i].competency_metric__id === obj.id) {
                                count = count + 1;
                                some_id = callbackData.data.default_competency_metrics[i].id
                            }
                        }
                        
                        if (count > 0) {
                            formatedData.push({
                                ...obj,
                                some_id,
                                default: 'Default',
                                'access': ' fa fa-check text-success',
                            })
                        }
                        if (count === 0) {
                            formatedData.push({
                                ...obj,
                                default: 'Default',
                                'access': ' fa fa-times text-danger',
                            })
                        }
                    });
    
    
                    let formatedData_org = []
                            
                    this.state.tableData.organisation_metric_list.map(function(obj) { 
                        let count = 0;
                        let some_id = 0;
                        for (let i = 0; i < callbackData.data.organisation_competency_metrics.length; i++) {
                            if (callbackData.data.organisation_competency_metrics[i].assessment_organisation_competency === obj.id) {
                                count = count + 1;
                                some_id = callbackData.data.organisation_competency_metrics[i].id
                            }
                        }
                        if (count > 0) {
                            formatedData_org.push({
                                ...obj,
                                some_id,
                                default: 'Organisation',
                                'access': ' fa fa-check text-success',
                            })
                        }
                        if (count === 0) {
                            formatedData_org.push({
                                ...obj,
                                default: 'Organisation',
                                'access': ' fa fa-times text-danger',
                            })
                        }
                    });
    
                            
                    const tableData = {
                        combined_list: formatedData.concat(formatedData_org),
                        organisation_metric_list: formatedData_org,
                        default_compitency_metric_list: formatedData
                    }
    
                    this.setState({
                        tableData,
                        uneditable_combined_list: formatedData.concat(formatedData_org)
                    }, () => {
                    })
                }))
            })
        }))

        this.setState({navData: temp, buttonData: [
            {
                id: 1,
                name: 'Allow Access',
                toggler: this.toggleaddCompetency.bind(this),
                togglerModal: this.state.addCompetency,
                icon: 'fa fa-plus',
                disabled: 'disabled',
                title:'Allow Access'
            },
            {
                id: 2,
                name: 'Deny Access',
                toggler: this.toggleDenyCompetency.bind(this),
                togglerModal: this.state.denyCompetency,
                icon: 'fa fa-plus',
                disabled: 'disabled',
                title:'Deny Access'
            }
        ], buttonData2: [
            {
                id: 1,
                name: 'Allow Access',
                toggler: this.toggleaddCompetency2.bind(this),
                togglerModal: this.state.addCompetency2,
                icon: 'fa fa-plus',
                disabled: 'disabled',
                title:'Allow Access'
            },
            {
                id: 2,
                name: 'Deny Access',
                toggler: this.toggleDenyCompetency2.bind(this),
                togglerModal: this.state.denyCompetency2,
                icon: 'fa fa-plus',
                disabled: 'disabled',
                title:'Deny Access'
            }
        ]})
    }

    componentDidUpdate(prevProp, prevState) {

        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    toggleaddCompetency2(showModal) {
        this.setState({
            addCompetency2: showModal
        })
    }

    toggleDenyCompetency2(showModal) {
        this.setState({
            denyCompetency2: showModal
        })
    }

    toggleDenyCompetency(showModal) {
        this.setState({
            denyCompetency: showModal
        })
        // AddMetric.map(
        //     (data, i) => {
        //         this.resetData(data)
        //     }
        // )
    }

    toggleaddCompetency(showModal) {
        this.setState({
            addCompetency: showModal
        })
        AddMetric.map(
            (data, i) => {
                this.resetData(data)
            }
        )
    }

    resetData(data) {
        data.value = '';
        if (data.validation.required === true) {
            data.valid = false;
        }
    }


    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    actionSelected(data) {

    }

    toggleDetailsCompetency(showModal) {
        this.setState({
            competencyDetailsModal: true,
            competencyDetails: showModal
        })
    }

    toggleeditCompetency(showModal) {
        this.setState({
            editCompetency: true,
            competencyDetails: showModal
        })
    }

    toggledeleteCompetency(showModal) {
        this.setState({
            deleteCompetency: true,
            competencyDetails: showModal
        })
    }

    toggleEntireMetricsModal(showModal) {
        this.setState({
            competencyDetailsModal: showModal,
            editCompetency: showModal,
            deleteCompetency: showModal,
            addCompetency: showModal,
        })
    }

    onClickDeleteCompetency(type) {
        this.setState({
            deleteCompetency: false
        })
    }

    getCompetencyDetails() {

        const subTable = {
            data: [{
                name: 'Attribute Name',
                key: 'attribute__attribute_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                color: 'color'

            },
            {
                name: 'Competency Weight',
                key: 'competency_weight',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                color: 'color'
            },]
        }

        const subTableData = []
        this.state.competencyDetails.competency_values.map(
            (data, i) => {
                if (i < this.state.competencyDetails.competency_values.length) {
                    subTableData.push(
                        {
                            attribute__attribute_name: data.attribute__attribute_name,
                            competency_weight: data.competency_weight + '%'
                        }
                    )
                }
                if (i + 1 === this.state.competencyDetails.competency_values.length) {
                    subTableData.push(
                        {
                            attribute__attribute_name: 'Total',
                            competency_weight: '100%',
                            color: 'rgb(0, 128, 0)'
                        }
                    )
                }
            }
        )

        const returnData =
            <TableNew
                data={subTableData}
                columns={subTable.data}

            />

        return returnData
    }

    selectAllAssessment(data, clickToggle) {
        const { buttonData } = this.state;
        clickToggle === true ?
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = ''
                    this.setState({
                        reRenderSettingsHead: 2,
                        assessmentResponse: data
                    })
                }
            })
            :
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled'
                    this.setState({
                        reRenderSettingsHead: 1,
                        assessmentResponse: data
                    })
                }
            })
    }

    getSelectedData = (data) => {
        if (data.length !== 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, true)
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, false)
            })
        }
    }

    selectAllAssessment2(data, clickToggle) {
        const { buttonData2 } = this.state;
        clickToggle === true ?
            buttonData2.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = ''
                    this.setState({
                        reRenderSettingsHead: 2,
                        assessmentResponse: data
                    })
                }
            })
            :
            buttonData2.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled'
                    this.setState({
                        reRenderSettingsHead: 1,
                        assessmentResponse: data
                    })
                }
            })
    }

    getSelectedData2 = (data) => {
        if (data.length !== 0) {
            this.setState({ checkBoxData2: data }, () => {
                this.selectAllAssessment2(this.state.checkBoxData2, true)
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData2: data }, () => {
                this.selectAllAssessment2(this.state.checkBoxData2, false)
            })
        }
    }


    // this method is used to fetch the html tag data for add (and) remove modal
    getOrgData(checkBoxData) {
        const headings = [{
            'name': 'Competency Name',
            'textCenter':false
        },{
            'name': 'Access',
            'textCenter':true
        }]
        const keyNames = [{
            'name': 'competency_name'
        },]
       return AccessData(checkBoxData, headings, keyNames)
    }

    onAddCompetency(type) {
        if(type === 'Add') {
            this.props.dispatch(superAdminAction.combinedAllowAccessApi({analytics_organisation: +this.props.match.params.id, "competency_metrics":this.state.checkBoxData.filter(val => val.default === "Default").map(val => val.id), "assessment_organisation_competency":this.state.checkBoxData.filter(val => val.default !== "Default").map(val => val.id)}, (response) => {
                this.props.dispatch(superAdminAction.combinedMetricListApi({analytics_organisation: +this.props.match.params.id}, (callbackData) => {
                    let formatedData = []

                            
                    this.state.tableData.default_compitency_metric_list.map(function(obj) { 
                        let count = 0;
                        let some_id = 0;
                        for (let i = 0; i < callbackData.data.default_competency_metrics.length; i++) {
                            if (callbackData.data.default_competency_metrics[i].competency_metric__id === obj.id) {
                                count = count + 1;
                                some_id = callbackData.data.default_competency_metrics[i].id
                            }
                        }
                        if (count > 0) {
                            formatedData.push({
                                ...obj,
                                some_id,
                                default: 'Default',
                                'access': ' fa fa-check text-success',
                            })
                        }
                        if (count === 0) {
                            formatedData.push({
                                ...obj,
                                default: 'Default',
                                'access': ' fa fa-times text-danger',
                            })
                        }
                    });
                    
    
    
                    let formatedData_org = []
                            
                    this.state.tableData.organisation_metric_list.map(function(obj) { 
                        let count = 0;
                        let some_id = 0;
                        for (let i = 0; i < callbackData.data.organisation_competency_metrics.length; i++) {
                            if (callbackData.data.organisation_competency_metrics[i].assessment_organisation_competency === obj.id) {
                                count = count + 1;
                                some_id = callbackData.data.organisation_competency_metrics[i].id
                            }
                        }
                        if (count > 0) {
                            formatedData_org.push({
                                ...obj,
                                some_id,
                                default: 'Organisation',
                                'access': ' fa fa-check text-success',
                            })
                        }
                        if (count === 0) {
                            formatedData_org.push({
                                ...obj,
                                default: 'Organisation',
                                'access': ' fa fa-times text-danger',
                            })
                        }
                    });
    
                    
                            
                    const tableData = {
                        default_compitency_metric_list: formatedData,
                        organisation_metric_list: formatedData_org,
                        combined_list: formatedData.concat(formatedData_org)
                    }
    
                    this.setState({
                        tableData,
                        uneditable_combined_list: formatedData.concat(formatedData_org)
                    }, () => {
                        this.setState({
                            addCompetency: false,
                        }, () => {
                            this.updateMessageFunc(response)
                        })
                    })
                }))
            }))
        }else if(type === 'Cancel') {
            this.setState({
                addCompetency: false
            })
        }
    }

    onRemoveCompetency(type) {
        if(type === 'Remove') {
            this.props.dispatch(superAdminAction.combinedDenyAccessApi({"analytics_organisation_metrics":this.state.checkBoxData.map(val => val.some_id).filter(val => val !== null && val !== undefined)}, (response) => {
                this.props.dispatch(superAdminAction.combinedMetricListApi({analytics_organisation: +this.props.match.params.id}, (callbackData) => {
                    let formatedData = []
                            
                    this.state.tableData.default_compitency_metric_list.map(function(obj) { 
                        let count = 0;
                        let some_id = 0;
                        for (let i = 0; i < callbackData.data.default_competency_metrics.length; i++) {
                            if (callbackData.data.default_competency_metrics[i].competency_metric__id === obj.id) {
                                count = count + 1;
                                some_id = callbackData.data.default_competency_metrics[i].id
                            }
                        }
                        if (count > 0) {
                            formatedData.push({
                                ...obj,
                                some_id,
                                default: 'Default',
                                'access': ' fa fa-check text-success',
                            })
                        }
                        if (count === 0) {
                            formatedData.push({
                                ...obj,
                                default: 'Default',
                                'access': ' fa fa-times text-danger',
                            })
                        }
                    });
    
    
                    let formatedData_org = []
                            
                    this.state.tableData.organisation_metric_list.map(function(obj) { 
                        let count = 0;
                        let some_id = 0;
                        for (let i = 0; i < callbackData.data.organisation_competency_metrics.length; i++) {
                            if (callbackData.data.organisation_competency_metrics[i].assessment_organisation_competency === obj.id) {
                                count = count + 1;
                                some_id = callbackData.data.organisation_competency_metrics[i].id
                            }
                        }
                        if (count > 0) {
                            formatedData_org.push({
                                ...obj,
                                some_id,
                                default: 'Organisation',
                                'access': ' fa fa-check text-success',
                            })
                        }
                        if (count === 0) {
                            formatedData_org.push({
                                ...obj,
                                default: 'Organisation',
                                'access': ' fa fa-times text-danger',
                            })
                        }
                    });
    
                            
                    const tableData = {
                        default_compitency_metric_list: formatedData,
                        organisation_metric_list: formatedData_org,
                        combined_list: formatedData.concat(formatedData_org)
                    }
    
                    this.setState({
                        tableData,
                        uneditable_combined_list: formatedData.concat(formatedData_org)
                    }, () => {
                        this.setState({
                            denyCompetency: false
                        }, () => {
                            this.updateMessageFunc(response)
                        })
                    })
                }))
            }))
        }else if(type === 'Cancel') {
            this.setState({
                denyCompetency: false
            })
        }
    }

    onAddCompetency2(type) {
        if(type === 'Add') {
            this.props.dispatch(superAdminAction.combinedAllowAccessApi({analytics_organisation: +this.props.match.params.id, "competency_metrics":[], "assessment_organisation_competency":this.state.checkBoxData2.map(val => val.id)}, (response) => {
                this.props.dispatch(superAdminAction.combinedMetricListApi({analytics_organisation: +this.props.match.params.id}, (callbackData) => {
                    let formatedData = []
                            
                    this.state.tableData.default_compitency_metric_list.map(function(obj) { 
                        let count = 0;
                        let some_id = 0;
                        for (let i = 0; i < callbackData.data.default_competency_metrics.length; i++) {
                            if (callbackData.data.default_competency_metrics[i].competency_metric__id === obj.id) {
                                count = count + 1;
                                some_id = callbackData.data.default_competency_metrics[i].id
                            }
                        }
                        if (count > 0) {
                            formatedData.push({
                                ...obj,
                                some_id,
                                'access': ' fa fa-check text-success',
                            })
                        }
                        if (count === 0) {
                            formatedData.push({
                                ...obj,
                                'access': ' fa fa-times text-danger',
                            })
                        }
                    });
    
    
                    let formatedData_org = []
                            
                    this.state.tableData.organisation_metric_list.map(function(obj) { 
                        let count = 0;
                        let some_id = 0;
                        for (let i = 0; i < callbackData.data.organisation_competency_metrics.length; i++) {
                            if (callbackData.data.organisation_competency_metrics[i].assessment_organisation_competency === obj.id) {
                                count = count + 1;
                                some_id = callbackData.data.organisation_competency_metrics[i].id
                            }
                        }
                        if (count > 0) {
                            formatedData_org.push({
                                ...obj,
                                some_id,
                                'access': ' fa fa-check text-success',
                            })
                        }
                        if (count === 0) {
                            formatedData_org.push({
                                ...obj,
                                'access': ' fa fa-times text-danger',
                            })
                        }
                    });
    
                            
                    const tableData = {
                        default_compitency_metric_list: formatedData,
                        organisation_metric_list: formatedData_org
                    }
    
                    this.setState({
                        tableData
                    }, () => {
                        this.setState({
                            addCompetency2: false
                        }, () => {
                            this.updateMessageFunc(response)
                        })
                    })
                }))
            }))
        }else if(type === 'Cancel') {
            this.setState({
                addCompetency2: false
            })
        }
    }

    onRemoveCompetency2(type) {
        if(type === 'Remove') {
            this.props.dispatch(superAdminAction.combinedDenyAccessApi({"analytics_organisation_metrics":this.state.checkBoxData2.map(val => val.some_id).filter(val => val !== null && val !== undefined)}, (response) => {
                this.props.dispatch(superAdminAction.combinedMetricListApi({analytics_organisation: +this.props.match.params.id}, (callbackData) => {
                    let formatedData = []
                            
                    this.state.tableData.default_compitency_metric_list.map(function(obj) { 
                        let count = 0;
                        let some_id = 0;
                        for (let i = 0; i < callbackData.data.default_competency_metrics.length; i++) {
                            if (callbackData.data.default_competency_metrics[i].competency_metric__id === obj.id) {
                                count = count + 1;
                                some_id = callbackData.data.default_competency_metrics[i].id
                            }
                        }
                        if (count > 0) {
                            formatedData.push({
                                ...obj,
                                some_id,
                                'access': ' fa fa-check text-success',
                            })
                        }
                        if (count === 0) {
                            formatedData.push({
                                ...obj,
                                'access': ' fa fa-times text-danger',
                            })
                        }
                    });
    
    
                    let formatedData_org = []
                            
                    this.state.tableData.organisation_metric_list.map(function(obj) { 
                        let count = 0;
                        let some_id = 0;
                        for (let i = 0; i < callbackData.data.organisation_competency_metrics.length; i++) {
                            if (callbackData.data.organisation_competency_metrics[i].assessment_organisation_competency === obj.id) {
                                count = count + 1;
                                some_id = callbackData.data.organisation_competency_metrics[i].id
                            }
                        }
                        if (count > 0) {
                            formatedData_org.push({
                                ...obj,
                                some_id,
                                'access': ' fa fa-check text-success',
                            })
                        }
                        if (count === 0) {
                            formatedData_org.push({
                                ...obj,
                                'access': ' fa fa-times text-danger',
                            })
                        }
                    });
    
                            
                    const tableData = {
                        default_compitency_metric_list: formatedData,
                        organisation_metric_list: formatedData_org
                    }
    
                    this.setState({
                        tableData
                    }, () => {
                        this.setState({
                            denyCompetency2: false
                        }, () => {
                            this.updateMessageFunc(response)
                        })
                    })
                }))
            }))
        }else if(type === 'Cancel') {
            this.setState({
                denyCompetency2: false
            })
        }
    }

    enableAddOrRemove = (checkBoxData, type) => {
        let count = 0;
        for (let i = 0; i < checkBoxData.length; i++) {
            if (checkBoxData[i].access === (type === 'add' ? ' fa fa-check text-success' : ' fa fa-times text-danger')) {
                count = count + 1;
            }
        }
        return count === checkBoxData.length ? false : true;
    }


    updateMessageFunc = (response) => {
        this.setState({
            updateMessage: {
                status: response.status,
                text: `<div className = " text-center">
                <p className = "font-weight-bold">${(response.status === 200 || response.status === 201) ? 'Success!' : 'Error!'}</p>
                <p> ${response.data.message}.</p>
            </div>`,
                heading: response.config.url.includes('deny/access') ? 'Remove Metric' : 'Assign Metric',
                headerColor: (response.status === 200 || response.status === 201) ? `` : `bg-danger`,
                headingIcon: (response.status === 200 || response.status === 201) ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
            },
            updateModalState: true
        })
    }

    filterData(data) {
        let tableData = {
            ...this.state.tableData,
            combined_list: data
        }
        this.setState({
            tableData
        });
    }

    compareBy(key) {
        return tableSort(key, this.state.sortType)
    }

    sortBy(columnKey, type) {
        
        this.setState({ sortType: type })
        let arrayCopy = this.state.tableData.combined_list
        arrayCopy.sort(this.compareBy(columnKey));
        this.setState({ tableData: {
            ...this.state.tableData,
            combined_list: arrayCopy
        } });
    }


    render() {

        const tables = {
            Team: [{
                name: 'Name',
                key: 'competency_name',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: ''

            },
            {
                name: 'Type',
                key: 'competency_type__competency_name',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: ''
            }, {
                name: 'Metric Type',
                key: 'default',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: ''
            }, {
                name: 'Access',
                key: 'EDIT',
                link: '',
                sort: false,
                type: 'icon',
                content: 'access',
                alignCenter: true,
                headingAlign: true,
            }
            
            // {
            //     name: 'Top 5 Name',
            //     key: 'top_five_name',
            //     link: '',
            //     sort: false,
            //     type: 'text',
            //     content: '',
            //     alignCenter: false,
            //     link: ''
            // },
            // {
            //     name: 'Type',
            //     key: 'competency_type__competency_name',
            //     link: '',
            //     sort: false,
            //     type: 'text',
            //     content: '',
            //     alignCenter: false,
            //     link: ''
            // },
            // {
            //     name: '',
            //     key: 'DETAILS',
            //     link: '',
            //     sort: false,
            //     type: 'Button',
            //     content: 'Details',
            //     alignCenter: false,
            //     link: '',
            //     title:'Details'
            // }
            ]
        }


        this.state.editCompetency === true &&
            AddMetric.map(
                (data, i) => {
                    data.value = this.state.competencyDetails[data.key] === 0 ? '' : this.state.competencyDetails[data.key];
                    data.valid = true;
                }
            )

        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={superAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">Metrics</h5>
                        <UtilityNav
                            actionButtons={this.state.buttonData}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                            searchBar={true}
                            tableData={this.state.uneditable_combined_list}
                            FilterFunc={this.filterData.bind(this)}
                            columns={tables.Team.filter(team => team.name !== 'Access')}
                        />

                        <TableNew
                            data={this.state.tableData.combined_list}
                            columns={tables.Team}
                            onClickDetailsButton={this.toggleDetailsCompetency.bind(this)}
                            // onClickEditButton={this.toggleeditCompetency.bind(this)}
                            // onClickRemoveorDeleteButton={this.toggledeleteCompetency.bind(this)}
                            checkbox="true"
                            selectCheckBox={this.selectAllAssessment.bind(this)}
                            getData={this.getSelectedData.bind(this)}
                            CheckKey={"id"}
                            RowGrouping={{
                                groups: [
                                    {
                                        name:'Default',
                                        active: true
                                    },
                                    {
                                        name: 'Organisation',
                                        active: false
                                    }
                                ],
                                groupKey: 'default',
                            }}
                            pagination={true}
                            paginationAmount={10}
                            sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                            sortType={this.state.sortType}
                        />

                        {/* <h5 className="jumbo">Organisation Metrics</h5>
                        <UtilityNav
                            actionButtons={this.state.buttonData2}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />

                        <TableNew
                            data={this.state.tableData.organisation_metric_list}
                            columns={tables.Team}
                            onClickDetailsButton={this.toggleDetailsCompetency.bind(this)}
                            // onClickEditButton={this.toggleeditCompetency.bind(this)}
                            // onClickRemoveorDeleteButton={this.toggledeleteCompetency.bind(this)}
                            checkbox="true"
                            selectCheckBox={this.selectAllAssessment2.bind(this)}
                            getData={this.getSelectedData2.bind(this)}
                            CheckKey={"id"}
                            // sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                            // sortType={this.state.sortType}
                        /> */}

                        {
                            this.state.addCompetency &&
                            <ModalComponent
                                showModal={this.state.addCompetency}
                                heading="Add Metric"
                                toggleEntireModal={this.toggleaddCompetency.bind(this)}
                                htmlTag={this.getOrgData(this.state.checkBoxData)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData, 'add') ? [{
                                    'buttonName': 'Add',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onAddCompetency(type)}
                            />
                        }

                        {
                            this.state.denyCompetency &&
                            <ModalComponent
                                showModal={this.state.denyCompetency}
                                heading="Remove Metric"
                                toggleEntireModal={this.toggleDenyCompetency.bind(this)}
                                htmlTag={this.getOrgData(this.state.checkBoxData)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData, 'remove') ? [{
                                    'buttonName': 'Remove',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onRemoveCompetency(type)}
                            />
                        }

                        {
                            this.state.addCompetency2 &&
                            <ModalComponent
                                showModal={this.state.addCompetency2}
                                heading="Add Organisation Metric"
                                toggleEntireModal={this.toggleaddCompetency2.bind(this)}
                                htmlTag={this.getOrgData(this.state.checkBoxData2)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData2, 'add') ? [{
                                    'buttonName': 'Add',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onAddCompetency2(type)}
                            />
                        }

                        {
                            this.state.denyCompetency2 &&
                            <ModalComponent
                                showModal={this.state.denyCompetency2}
                                heading="Remove Organisation Metric"
                                toggleEntireModal={this.toggleDenyCompetency2.bind(this)}
                                htmlTag={this.getOrgData(this.state.checkBoxData2)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData2, 'remove') ? [{
                                    'buttonName': 'Remove',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onRemoveCompetency2(type)}
                            />
                        }

                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false })}
                            />
                        }

                        {
                            this.state.competencyDetailsModal &&
                            <ModalComponent
                                showModal={this.state.competencyDetailsModal}
                                heading={`Competency - ${this.state.competencyDetails.metric_name}`}
                                toggleEntireModal={this.toggleEntireMetricsModal.bind(this)}
                                htmlTag={this.getCompetencyDetails()}
                                footerNonSubmitButton={[ {
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => { this.setState({ competencyDetailsModal: false }) }}
                            />
                        }

                        {
                            this.state.editCompetency &&
                            <ModalComponent
                                showModal={this.state.editCompetency}
                                heading="Edit Metric/Competency/Value"
                                formData={AddMetric}
                                action={this.actionSelected.bind(this)}
                                toggleEntireModal={this.toggleEntireMetricsModal.bind(this)}
                                footerFormSubmitButton={['Add', 'Cancel']}
                                selectKey={['metric_type']}
                                selects={['metric_type_name']}
                            />
                        }

                        {
                            this.state.deleteCompetency &&
                            <ModalComponent
                                showModal={this.state.deleteCompetency}
                                heading="Delete Metric/Competency/Value"
                                toggleEntireModal={this.toggleEntireMetricsModal.bind(this)}
                                htmlText={`<div className = "ml-1 ml-md-3 pl-1 pl-md-3 ">
                                <p className="">Are you sure you want to delete the Competency :</p>
                                <span>Team Name:</span><span className = 'font-weight-bold '>&nbsp;${this.state.competencyDetails.metric_name}</span>
                              </div>`}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Delete',
                                }, {
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type)=>this.onClickDeleteCompetency(type)}
                            />
                        }

                    </div>

                </div>
            </div>
        )
    }
}



function mapStateToProps(state) {
    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';
    return {
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(DefineMetrics);



// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/DefineMetrics/index.js